import React from 'react';

export function WidgetAccount ({ account }) {
    return (<span>{account[0]} {account[1]}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetAccount.displayName = 'WidgetAccount';
}
